import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { getCurrentUser } from '../lib/phpAuth'
import { consumePostLoginRedirect } from '../lib/postLoginRedirect'
import './AuthCallback.css'

function AuthCallback() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [processed, setProcessed] = useState(false)

  useEffect(() => {
    if (processed) return

    const processCallback = async () => {
      setProcessed(true)

      const error = searchParams.get('error')
      if (error) {
        navigate('/?error=' + encodeURIComponent(error), { replace: true })
        return
      }

      try {
        const user = await getCurrentUser()
        if (user) {
          navigate(consumePostLoginRedirect('/intranet'), { replace: true })
          return
        }
        navigate('/?error=auth_failed', { replace: true })
      } catch (err) {
        console.error('Auth callback error:', err)
        navigate('/?error=auth_failed', { replace: true })
      }
    }

    void processCallback()
  }, [processed, navigate, searchParams])

  return (
    <div className="auth-callback-container">
      <div className="auth-callback-spinner" />
      <p>Přihlašování…</p>
    </div>
  )
}

export default AuthCallback
